"use client";
import React from "react";
import { FormattedMessage } from "react-intl";
import { motion } from "framer-motion";
import { createAndRedirectToNewHub } from "../../utils/phoenix-utils";

export function CreateRoomButton() {
  return (
    <motion.button
      whileHover={{ scale: 1.05, y: -2 }}
      whileTap={{ scale: 0.97, y: 0 }}
      transition={{ type: "spring", stiffness: 200, damping: 15 }}
      onClick={e => {
        e.preventDefault();
        createAndRedirectToNewHub(null, null, false);
      }}
      className="
        relative isolate overflow-hidden
        px-12 py-5 rounded-2xl
        font-plusjakarta font-semibold uppercase tracking-wider
        text-text1 bg-background1
        hover:bg-background2
        transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]
        shadow-[0_0_0_2px_var(--border1-color),0_6px_18px_rgba(0,0,0,0.25)]
        hover:shadow-[0_0_0_2px_var(--border2-color),0_10px_28px_rgba(0,0,0,0.35)]
        active:shadow-[inset_0_3px_10px_rgba(0,0,0,0.4)]
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border1
      "
    >
      {/* Subtle ambient glow */}
      <span
        className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{
          background: "radial-gradient(circle at 50% 100%, rgba(255,255,255,0.08), transparent 70%)"
        }}
      />

      {/* Gloss effect */}
      <span
        className="absolute top-0 left-0 w-full h-1/2 pointer-events-none"
        style={{
          background: "linear-gradient(to bottom, rgba(255,255,255,0.12), transparent)"
        }}
      />

      {/* Text */}
      <span className="relative z-10 text-[17px] drop-shadow-[0_1px_1px_rgba(0,0,0,0.25)]">
        <FormattedMessage id="create-room-button" defaultMessage="Create Room" />
      </span>

      {/* Bottom underglow */}
      <span
        className="absolute -bottom-3 left-1/2 w-3/4 h-2/3 -translate-x-1/2 blur-2xl opacity-40"
        style={{
          background: "radial-gradient(circle, var(--color-accent) 0%, transparent 70%)"
        }}
      />
    </motion.button>
  );
}
